import React from "react";

function AppointmentView() {

    return (

        <div className="container mt-4">

            <h3>Appointment Details</h3>

            <p>Patient details here</p>

            <button className="btn btn-success">
                Attend
            </button>

        </div>

    )

}

export default AppointmentView